import { Tooltip } from '@mui/material';
import React, { ReactElement } from 'react';

import { DATA_TEST } from '../enums';

import { tooltipOffsetProps } from './styleConstants';

interface ISubmenuItemTooltipProps {
  children: ReactElement;
  title: string;
}

export const SubmenuItemTooltip: React.FC<ISubmenuItemTooltipProps> = ({ children, title }) => {
  return (
    <Tooltip
      data-test={DATA_TEST.submenu_item_overflow_tooltip}
      title={title}
      placement="top-start"
      enterNextDelay={500}
      disableInteractive={true}
      {...tooltipOffsetProps}
    >
      {children}
    </Tooltip>
  );
};
